import { getAffiliateUrl } from '../data/affiliateLinks';
import { propFirmLogos } from '../data/propFirmLogos';

function ComparisonTablePro({ firms }) {
  return (
    <div className="overflow-x-auto rounded-2xl border border-yellow-700">
      <table className="min-w-full text-yellow-100 text-sm">
        <thead className="bg-gray-800">
          <tr>
            <th className="p-3 text-left">Firm</th>
            <th className="p-3 text-left">Features</th>
            <th className="p-3 text-left">Daily Drawdown</th>
            <th className="p-3 text-left">Evaluation</th>
            <th className="p-3 text-left">Promo</th>
            <th className="p-3 text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          {firms.map((firm, index) => (
            <tr
              key={firm.id}
              className={
                index % 2 === 0
                  ? 'bg-gray-900 hover:bg-gray-800'
                  : 'bg-gray-950 hover:bg-gray-800'
              }
            >
              <td className="p-4 flex items-center gap-3 min-w-[200px]">
                <img
                  src={propFirmLogos[firm.id]?.logo}
                  alt={firm.name}
                  className="w-10 h-10 object-contain bg-black p-1 rounded-lg"
                />
                <div>
                  <div className="font-bold text-yellow-400">{firm.name}</div>
                  <div className="text-xs text-yellow-300">{firm.bestFor}</div>
                  <div className="flex gap-1 mt-1">
                    {[...Array(Math.round(firm.rating))].map((_, i) => (
                      <div key={i} className="w-3 h-3 bg-yellow-400 rounded-full" />
                    ))}
                  </div>
                </div>
              </td>

              <td className="p-4 text-yellow-300 text-xs">
                <div>Max Funding: {firm.features.maxFunding}</div>
                <div>Profit Split: {firm.features.profitSplit}</div>
                <div>Payout: {firm.features.payout}</div>
              </td>

              <td className="p-4 text-yellow-300 text-xs">
                {firm.features?.dailyDrawdown || '-'}
              </td>

              <td className="p-4 text-yellow-300 text-xs">
                {firm.features?.evaluationTypes?.length > 0
                  ? firm.features.evaluationTypes.join(', ')
                  : '-'}
              </td>

              <td className="p-4 text-yellow-300 font-bold">
                <span className="bg-yellow-400 text-black text-xs px-3 py-1 rounded-full font-bold">
                  Save {firm.evaluation.discount.percent}%
                </span>
              </td>

              <td className="p-4">
                <a
                  href={getAffiliateUrl(firm.id)}
                  target="_blank"
                  rel="noopener"
                  className="block w-full bg-yellow-400 text-black text-center text-xs font-bold py-2 px-4 rounded-full hover:bg-yellow-300 transition"
                >
                  Get Funded
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ComparisonTablePro;